import ContactMeLayout from "./ContactMeLayout";


function ContactMeMain(){
    return (
        <>
            <div className="pt-4">
                <ContactMeLayout />
            </div>
        </>
    );
}

export default ContactMeMain;